import styled from 'styled-components';

interface IMoveableWrapperProps {
    highlightMoveable?: boolean;
    viewOrigin?: boolean;
}

export const MoveableWrapper = styled.div.attrs(() => ({
    className: String('ap-moveable-wrapper')
})) <IMoveableWrapperProps>`
    display: inline-block;

    & .moveable-line {
        display: ${({ highlightMoveable }) => (highlightMoveable ? '' : 'none')};
    }

    & .moveable-control.moveable-origin {
        display: ${({ viewOrigin }) => (viewOrigin ? '' : 'none')};
    }
`;
